<script setup lang="ts">
/**
 * Terracota = ACCION (lo que se pulsa). Verde zellige = CONFIRMACION.
 * No se intercambian. Altura minima 52px: es un boton que se pulsa con el
 * pulgar, de pie, en una barberia.
 */
withDefaults(defineProps<{
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger'
  size?: 'md' | 'sm'
  loading?: boolean
  disabled?: boolean
  type?: 'button' | 'submit'
}>(), {
  variant: 'primary',
  size: 'md',
  type: 'button',
})

const classes = {
  primary: 'bg-terracotta text-white hover:bg-terracotta-dark',
  secondary: 'bg-surface text-ink border border-line hover:bg-muted-bg',
  ghost: 'text-ink-muted hover:bg-muted-bg',
  danger: 'bg-surface text-terracotta border border-terracotta hover:bg-terracotta-soft',
}
</script>

<template>
  <button
    :type="type"
    :disabled="disabled || loading"
    class="inline-flex items-center justify-center gap-2 rounded-control font-semibold transition disabled:opacity-50 disabled:cursor-not-allowed"
    :class="[classes[variant], size === 'sm' ? 'min-h-11 px-3 text-sm' : 'min-h-13 px-5 text-[15px]']"
  >
    <svg v-if="loading" class="size-4 animate-spin" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" opacity="0.25" />
      <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
    </svg>
    <slot />
  </button>
</template>
